import { CalendarClock } from '@/lib/icons'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { FieldBinding } from './NumberField'
import { NumberField } from './NumberField'

export interface CheckScheduleSectionProps {
  firstCheckDays: FieldBinding
  disabled: boolean
}

/**
 * "📅 Tekshiruv jadvali" bo'limi. Video uchun BITTA tekshiruv — shu kunda (postedAt dan
 * hisoblab) prosmotr kiritiladi va hisob darhol yakunlanadi.
 */
export function CheckScheduleSection({ firstCheckDays, disabled }: CheckScheduleSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CalendarClock size={16} aria-hidden="true" /> Tekshiruv jadvali
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col divide-y divide-app-border">
        <NumberField
          id="settings-first-check-days"
          label="Tekshiruv"
          unit="kundan keyin"
          value={firstCheckDays.value}
          onChange={firstCheckDays.onChange}
          error={firstCheckDays.error}
          disabled={disabled}
          placeholder="Masalan: 15"
        />
      </CardContent>
    </Card>
  )
}
